import React from "react";
import { Container } from "react-bootstrap";
import logoMark from "../../assets/logos/header_logo.png";

const footerLinks = [
  { label: "The problem", href: "#problem" },
  { label: "What we do", href: "#what-we-do" },
  { label: "Where the money is", href: "#money" },
  { label: "How we start", href: "#how" },
  { label: "Find out in two weeks", href: "#contact" },
];

const MidstreamFooter = ({
  segment = "Midstream",
  tagline = "Decision intelligence for midstream operators. Source to settlement, in one model.",
  links = footerLinks,
}) => {
  return (
    <footer className="ms-footer">
      <Container>
        <div className="ms-footer-top">
          <div className="ms-footer-brand">
            <div className="ms-brand">
              <img src={logoMark} alt="Dsider" />
              <span>Dsider</span>
            </div>
            <p>
              {tagline}
            </p>
          </div>
          <div className="ms-footer-cols">
            <div>
              <span className="ms-footer-label">Contact</span>
              <a href="mailto:info@dsider.app">info@dsider.app</a>
              <span>Houston, Texas</span>
            </div>
            <div>
              <span className="ms-footer-label">Navigation</span>
              {links.map((l) => (
                <a href={l.href} key={l.href}>
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="ms-footer-bottom">
          <span>© {new Date().getFullYear()} Dsider Inc. All rights reserved.</span>
          <span>
            {segment} <em>EBITDA You Can Defend</em>
          </span>
        </div>
      </Container>
    </footer>
  );
};

export default MidstreamFooter;
